import { UserRole } from 'shared/types/userRole';
import { isAdmin } from '../../role/isAdmin';
import { isClientAdmin } from '../../role/isClientAdmin';
import { isManager } from '../../role/isManager';

export function isAtLeastManager(role: UserRole): boolean {
  return isManager(role) || isAdmin(role) || isClientAdmin(role);
}
